import type { U2000CriteriaStaticOption } from "../../../u2000Core/components/tables/basic/U2000BasicTableList";
import { getOperationTypeLabel } from "../../../u3141LandRegister/components/common/U3141LotOperationType";
import type { U3141LotDetailOperationTypeFromInitLU } from "../../../u3141LandRegister/U3141Service";

function isInitOperationTypeActive(t: U3141LotDetailOperationTypeFromInitLU): boolean {
  return t.active !== false;
}

/** Options ComboBox critère recherche liste U3142 (types actifs initLU uniquement). */
export function buildU3142OperationTypeCriteriaOptions(
  language: string,
  initTypes?: U3141LotDetailOperationTypeFromInitLU[],
): U2000CriteriaStaticOption[] {
  if (!initTypes?.length) return [];
  const lang = language || "fr";
  return initTypes
    .filter((t) => isInitOperationTypeActive(t))
    .map((t) => ({
      value: t.operationTypeCode,
      label: getOperationTypeLabel(t.operationTypeCode, lang, initTypes),
    }))
    .sort((a, b) => a.label.localeCompare(b.label, lang, { sensitivity: "base" }));
}
